import React from "react";
import { Check } from "lucide-react";
import { CLIENTS, SITE, BRAND_POSTERS } from "../site.config";

const MISSION_POINTS = [
  "Professional, reliable service",
  "Honest advice & competitive prices",
  "Quality products from trusted suppliers",
  "Expert installation with attention to detail",
  "A clean, tidy and respectful service",
  "Flooring you'll be proud of for years",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="section-pad bg-moffat-paper"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          {/* Left: text */}
          <div className="lg:col-span-7">
            <p className="font-script text-3xl text-moffat-red leading-none">
              About us
            </p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-moffat-navy mt-3 uppercase leading-[0.95]">
              Trusted local<br />
              flooring<br />
              <span className="brush-underline text-moffat-charcoal">specialists.</span>
            </h2>
            <p className="mt-6 text-base sm:text-lg text-moffat-text leading-relaxed">
              Welcome to <strong>Carpet & Lino Fitted by A.Moffat</strong> —
              proudly serving County Durham and the surrounding areas. We
              specialise in supplying and fitting high-quality flooring for
              homes, landlords, letting agents and commercial properties.
            </p>
            <p className="mt-4 text-base text-moffat-muted leading-relaxed">
              From your free measure and quotation through to the final
              installation, expect honest advice, competitive prices, reliable
              workmanship and a friendly, professional service you can trust.
            </p>

            <ul className="mt-7 grid sm:grid-cols-2 gap-3">
              {MISSION_POINTS.map((p) => (
                <li key={p} className="flex items-start gap-3 text-[15px]">
                  <span className="mt-0.5 h-5 w-5 rounded-sm bg-moffat-red flex items-center justify-center flex-shrink-0">
                    <Check size={13} strokeWidth={3.5} className="text-white" />
                  </span>
                  <span className="font-semibold text-moffat-text leading-snug">{p}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 bg-moffat-navy text-white px-5 py-4 rounded-sm inline-flex items-center gap-3 border-l-4 border-moffat-red">
              <span className="font-display text-lg md:text-xl">QUALITY WORK</span>
              <span className="h-1.5 w-1.5 rounded-full bg-moffat-red" />
              <span className="font-display text-lg md:text-xl">GREAT FINISH</span>
              <span className="h-1.5 w-1.5 rounded-full bg-moffat-red" />
              <span className="font-display text-lg md:text-xl">BUILT TO LAST</span>
            </div>
          </div>

          {/* Right: who we work with + poster */}
          <div className="lg:col-span-5 space-y-5">
            <div className="relative rounded-sm overflow-hidden border border-moffat-line shadow-lg bg-moffat-navy">
              <img
                src={BRAND_POSTERS.company}
                alt="Reliable & professional service"
                className="w-full h-auto block"
              />
            </div>

            <div className="bg-white border border-moffat-line rounded-sm p-6">
              <p className="font-script text-2xl text-moffat-red leading-none">
                Who we work with
              </p>
              <h3 className="font-display text-xl text-moffat-navy mt-2 uppercase">
                Domestic, Commercial & Letting
              </h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {CLIENTS.map((c) => (
                  <span
                    key={c}
                    className="text-[13px] font-semibold text-moffat-navy bg-moffat-cream border border-moffat-line rounded-full px-3 py-1.5"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
